
var $form;
var multistepFormInstance;
var currAddress = '';

$(document).ready(function() {
        
    var $container = $("#afvalpas-aanvragen");   
    $form = $("#form-afvalpas-aanvragen");
    
    var $postcodeField = $("#form_postcode");
    
    var validationOpts = {
        messages: {
            voorwaarden: "U dient akkoord te gaan met de voorwaarden",
            request_type: "Maak een keuze a.u.b."
        }
        
        // rules: {
        //     huisnummer: {      
        //         required: true,
        //         remote: {
        //             url: ajax_url,
        //             type: "post",
        //             data: {
        //                 postcode: function() {
        //                     return $postcodeField.val();
        //                 },
        //                 action: 'dar-find-address'
        //             }
        //         }
        //     }
        // }
    };
        
    multistepFormInstance = multistepForm($container, validationOpts, afvalpasStepValidation, submitAfvalpasForm);

    //check first step. If request type is 'new' hide next button, and show description
    let $requestTypeInput = $("input[name=request_type]");
    $requestTypeInput.on("change",function(){
        $('.choice-option-description').removeClass('active');
        let $nextStepBtn = $(this).closest('.step.active').find('.nextStep');
        if ($nextStepBtn.length > 0 && $nextStepBtn.is(":hidden")) {
            $nextStepBtn.show();
        }
        let selectedRequestType = $requestTypeInput.filter(":checked").val();
        if(selectedRequestType === 'new'){
            $('.choice-option-description[data-choice-option="request_type_new"]').addClass('active');
            if($nextStepBtn.length>0){
                $nextStepBtn.hide();
            }
        }
    });

});

function afvalpasStepValidation(step, callback){
    
    if(step === 1){
        var data = $form.serializeForm();
        
        if(data['request_type']==='new'){
            return;
        }
        else {
            callback(true);
        }

    }
    else if(step === 2){
        showLoader();   
        var data = $form.serializeForm();     
        
        ajax('validate-afvalpas-request', data, function(response){
            
            $("#copy_naam").text(data.naam);
            $("#copy_email").text(data.email);
            
            $("#autofill_straat").text(response.adres.straat);
            
            var huisnrStr = response.adres.huisnummer;
            if(response.adres.huisnummerToevoeging !== null) huisnrStr += ' '+response.adres.huisnummerToevoeging;
                
            $("#autofill_huisnummer").text(huisnrStr);
            
            $("#autofill_postcode").text(response.adres.postcode);
            $("#autofill_plaats").text(response.adres.plaats);
            $("#autofill_gemeente").text(response.adres.gemeente);
            $("#autofill_price").text(response.price);

            showLoader(false);            
            callback(true);
            
        }, function(err){
            console.error(err);
            callback(false, err.message);
            showLoader(false);
        });

    }
    else {
        callback(true);
    }
    
    
    
}

function submitAfvalpasForm(form, ev){
    
    ev.preventDefault(); 
    
    //Only submit on last step
    if(! $("#steps .step.active").hasClass('lastStep')) return;
    
    
    showLoader();   
    
    var data = $(form).serializeForm();
    ajax('process-afvalpas-aanvraag', data, function(res){
        
        //Redirect to payment page
        window.location.href = res.url;
        
    }, function(err){
        //wat dan..?
        console.error(err);
    });
    
}
